@for (toast of toastService.toasts; track toast) {
  <ngb-toast class="d-flex justify-content-around alert" [ngClass]="toast.class" [autohide]="true" [delay]="toast.delay || 5000" (hidden)="toastService.remove(toast)">
    @switch (toast.type) {
      @case ('success') {
        <img class="d-inline-block pe-2 me-1 align-middle" src="assets/images/notifier-success-tick.svg" />
        <span class="message d-inline-block align-middle">{{ toast.textOrTpl }}</span>
      }
      @case ('warning') {
        <img class="d-inline-block pe-2 me-1 align-middle" src="assets/images/legacy/error-octagon.svg" />
        <span class="message d-inline-block align-middle">{{ toast.textOrTpl }}</span>
      }
    }
  </ngb-toast>
}
